/** 
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Error Boundary Handlar
  Date: June 26, 2020
**/

import React, { } from 'react';
import {
  Toolbar,
  Button,
  Typography
} from '@material-ui/core';
import { useStoreState } from 'easy-peasy';
import { globalDateEntity } from '../../constants/applicationConstants';

// eslint-disable-next-line no-unused-vars
function LogedInUserInfo() {
  const loggedInUserInfo = useStoreState((state) => state.login.userInfo);
  return (
    <>
      <Typography>
        Organization: {loggedInUserInfo.orgs_title ? loggedInUserInfo.orgs_title : ''}
      </Typography>
      <Typography>User Name: {loggedInUserInfo.username ? loggedInUserInfo.username : ''}</Typography>
    </>
  );
}
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    const { configData } = this.props;
    if (this.state.hasError) {
      return <React.Fragment>
        <div style={{ width: '100%', background: configData && configData.primaryColor ? configData.primaryColor : globalDateEntity.primaryColor }}>
          <Toolbar>
            <div style={{ width: '100%' }}>
              <div style={{ float: 'left' }}>
                <Typography variant="h6" noWrap>
                  {configData && 
                  configData.preferences &&
                  configData.preferences.custom_branding ? configData.preferences.custom_branding : globalDateEntity.siteHeaderTitle}
                </Typography>
              </div>
              <div style={{ float: 'right' }}>
                <LogedInUserInfo />
              </div>
            </div>
          </Toolbar>
        </div>
        <div style={{ textAlign: 'center', width: '50%', margin: '120px auto 0px' }}>
          <Typography
            variant="h5"
            style={{
              textAlign: 'center',
              marginBottom: '5px',
              fontWeight: '600',
              padding: '10px 0px',
              border: '0px solid #ccc',
              width: '100%',
            }}
          >
            Something went wrong
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              window.location = '/';
            }}
          >
            Go Back to Home
          </Button>
        </div>
      </React.Fragment>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;